document.querySelectorAll('.reels-carousel').forEach(carousel=>{
 const track=carousel.querySelector('.reels-track');
 carousel.querySelectorAll('.reels-arrow').forEach(button=>button.addEventListener('click',()=>{
  const first=track.querySelector('.reel-card');if(!first)return;
  const step=first.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
  const next=button.classList.contains('next');
  if(next&&track.scrollLeft>=track.scrollWidth-track.clientWidth-3)track.scrollTo({left:0,behavior:'smooth'});
  else if(!next&&track.scrollLeft<3)track.scrollTo({left:track.scrollWidth,behavior:'smooth'});
  else track.scrollBy({left:step*(next?1:-1),behavior:'smooth'});
 }));
 carousel.querySelectorAll('.reel-card').forEach(card=>{
  const video=card.querySelector('video'),button=card.querySelector('.reel-play');if(!video||!button)return;
  video.controls=true;
  const sync=()=>card.classList.toggle('is-playing',!video.paused&&!video.ended);
  button.addEventListener('click',()=>video.play().then(sync).catch(sync));
  ['play','playing','pause','ended','loadeddata'].forEach(event=>video.addEventListener(event,sync));
  sync();
 });
});
